import { dataPlusSquareSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPlusSquareSolid = /*#__PURE__*/createIcon(dataPlusSquareSolid)
export default IconPlusSquareSolid
